import Vue from 'vue';
import Vuex from 'vuex';
import product from './modules/product';
import reserve from './modules/reserve';
import cart from './modules/cart';
import payment from './modules/payment';
import ui from './modules/ui';
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: { product, cart, reserve, payment, ui },
  plugins: [
    createPersistedState({
      paths: ['payment'],
      storage: window.sessionStorage,
    }),
  ],
});
